import _ from "react-dom";
var r, t = _;
if (process.env.NODE_ENV === "production")
  r = t.createRoot, t.hydrateRoot;
else {
  var e = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  r = function(o, n) {
    e.usingClientEntryPoint = !0;
    try {
      return t.createRoot(o, n);
    } finally {
      e.usingClientEntryPoint = !1;
    }
  };
}
export {
  r as c
};
